import React, { FC, HTMLAttributes } from "react";
import "./style.scss";
import { CtaSizeTypes, CtaTypes } from "../../../data/constants";
import { ToastNotifyError } from "../../../helpers/toast-helper";

export interface CtaProps extends HTMLAttributes<HTMLDivElement> {
  ctaSize: CtaSizeTypes;
  ctaType: CtaTypes;
  iconClass?: string;
  ctaText: string;
  customClass?: string;
  isIconPositionRight?: boolean;
  isDisabled?: boolean;
  onCtaClick: Function;
  disabledMessage?: string;
}

const CtaComponent: FC<CtaProps> = (props): React.JSX.Element => {

  function renderImagetag(): React.JSX.Element {
    return (
      <div className={`rista-sprite ${props.iconClass} ${props.isIconPositionRight ? "ml-8" : "mr-12"}`}></div>
    );
  }
  
  return (
    <button className={`custom-cta-main-container flex justify-center items-center
                        ${props.isDisabled ? "opacity-50 pointer-events-none" : ""} 
                        ${props.customClass || ""} ${props.ctaSize} ${props.ctaType}`}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          if (props.isDisabled) {
                            props.disabledMessage && ToastNotifyError(props.disabledMessage);
                            return;
                          }
                          props.onCtaClick();
                        }}>
      {
        (props.iconClass && !props.isIconPositionRight) ? renderImagetag() : null
      }
      {props.ctaText}
      {
        (props.iconClass && props.isIconPositionRight) ? renderImagetag() : null
      }
    </button>
  );
};

export default CtaComponent;